import { useEffect } from "react";
import confetti from "canvas-confetti";

export default function ConfettiBurst({ trigger }) {
  useEffect(() => {
    if (!trigger) return;
    const colors = ["#0a3cff", "#0a0a0a", "#ff1a1a", "#ffb800"];
    const end = Date.now() + 1500;
    (function frame() {
      confetti({ particleCount: 5, angle: 60, spread: 60, origin: { x: 0, y: 0.8 }, colors });
      confetti({ particleCount: 5, angle: 120, spread: 60, origin: { x: 1, y: 0.8 }, colors });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  }, [trigger]);
  return null;
}
